import air from "./guideAir";
import rail from "./guideRail";
import bus from "./guideBus";
import ground from "./guideGround";
import rideshare from "./guideRideshare";
import road from "./guideRoad";
import water from "./guideWater";
import stay from "./guideStay";
import deals from "./guideDeals";

export const GUIDES = { air, rail, bus, ground, rideshare, road, water, stay, deals };
